// Module
var code = "<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.perform()\"> <i class=\"fa fa-plus\"></i> {{'accesses.keychain.add.all.products' | translate}} </button> ";
// Exports
export default code;